export const THEME_CONSTANTS = Object.freeze({
  DARK: "dark",
  LIGHT: "light",
});
